module.exports = __webpack_public_path__ + "/favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./favicon.ico
// module id = 766
// module chunks = 10